import { Component, inject } from '@angular/core';
import { AuthSessionService } from '../../auth-session.service';

@Component({
  imports: [],
  selector: 'app-travel-guide',
  styleUrl: './travel-guide.scss',
  templateUrl: './travel-guide.html',
})
export class TravelGuide {
  private readonly authSession = inject(AuthSessionService);
  readonly version = this.authSession.paxVersion;
}
